export default {"src":"/_next/static/media/creperie.f3bba031.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};